// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zx-0";
export var tagInputDisabled = "_zx-1";